import React from 'react'

import { Logo } from '../../components/Logo'

import { Container } from './styles'

export const Home: React.FC = () => {
  return (
    <Container>
      <Logo />
    </Container>
  )
}
